<cds-icon shape="SystemAndDevicesSwap" class="me-1" />
<ng-container i18n>Switch Organization</ng-container>
